import './App.css';
import Random from "./component/Random";
function App() {
  return (
    <div className="container h-screen flex justify-center items-center mx-auto">
      <Random />
    </div>
  );
}

export default App;
